/* cc-search.js: zoeken in de stijl en met de logica van Cards Center (2026-10-19). Geen build-step.
   Vervangt Umino's predictive search (die koppelt alleen als #predictive-search bestaat; dat element staat niet
   meer in snippets/search-popup.liquid). Umino blijft de popup openen en sluiten via .top-search-toggle.

   Waarom zelf: Umino gebruikt /search/suggest zonder opties. Dat geeft maximaal 10 resultaten, zet op voorraad
   altijd eerst (Shopify-default unavailable_products=last) en negeert kaartnummers. De volledige zoekfunctie
   (/search) pakt nummers wel op en kent OR, maar alleen letterlijk: "16" vindt "016/135" niet. Daarom:
     1. parseQuery: de zoekterm indelen in woorden, kaartnummer (16, 016), breuk (16/135) en promocode (svp 85).
     2. buildServerQuery: nummers als varianten met OR, "pikachu 16" wordt "pikachu (16 OR 016)".
     3. ophalen via de Section Rendering API: /search?...&section_id=cc-search-data (sections/cc-search-data.liquid
        geeft JSON met titel, url, beschikbaarheid en de tegel-HTML uit snippets/cc-search-tile.liquid).
        Met een nummer erbij ook de naam los, zodat de rij aangevuld wordt met gelijkende kaarten.
     4. score: titels (Set - 025/165 - Naam - Variant, of SVP085 - Naam) vergelijken met de zoekterm.
        Voorraad telt niet mee in de volgorde. De hoogste score is het "Nauwkeurigste resultaat".
   Ook op de zoekpagina (sections/main-search.liquid): formulieren naar /search sturen de herschreven term mee,
   en de beste match van pagina 1 komt in het slot boven het grid.
   De pure functies (1, 2, 4) zijn ook in node te laden voor scripts/test-search.mjs. */
(function (root) {
  "use strict";

  /* ---------- 1. zoekterm en titel ontleden ---------- */
  // promo-prefixen zoals ze in de titels staan (SVP085, MEP081, SWSH050, BS4, TG05, ...)
  var PROMO = ["svp", "mep", "swsh", "smp", "sm", "xyp", "xy", "bwp", "bw", "hgss", "dp", "np", "tg", "gg", "rc", "bs", "sv", "me", "pop"];

  function norm(s) {
    return String(s || "")
      .toLowerCase()
      .normalize("NFD").replace(/[̀-ͯ]/g, "")
      .replace(/[’'`´.]/g, "")
      .replace(/&/g, " ")
      .replace(/[^a-z0-9/]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }
  function toInt(s) { var n = parseInt(s, 10); return isNaN(n) ? null : n; }

  function parseQuery(q) {
    var tokens = norm(q).split(" ").filter(Boolean);
    var p = { raw: String(q || "").trim(), words: [], num: null, numRaw: null, total: null, promo: null };
    for (var i = 0; i < tokens.length; i++) {
      var t = tokens[i], m;
      var hasNumber = p.num !== null || p.promo !== null;
      if (!hasNumber && (m = t.match(/^(\d{1,3})\/(\d{1,3})$/))) {
        p.num = toInt(m[1]); p.numRaw = m[1]; p.total = toInt(m[2]); continue;
      }
      if (!hasNumber && /^\d{1,3}$/.test(t)) {
        // "svp 85": het woord ervoor is een promo-prefix
        var prev = p.words[p.words.length - 1];
        if (prev && PROMO.indexOf(prev) >= 0) {
          p.words.pop(); p.promo = { prefix: prev, num: toInt(t), raw: t }; continue;
        }
        p.num = toInt(t); p.numRaw = t; continue;
      }
      if (!hasNumber && (m = t.match(/^([a-z]{1,5})(\d{1,3})$/)) && PROMO.indexOf(m[1]) >= 0) {
        p.promo = { prefix: m[1], num: toInt(m[2]), raw: m[2] }; continue;
      }
      p.words.push(t);
    }
    return p;
  }

  function pad(s, n) { s = String(s); while (s.length < n) s = "0" + s; return s; }
  function numberVariants(raw) {
    var n = toInt(raw), out = [];
    [raw, String(n), pad(n, 2), pad(n, 3)].forEach(function (v) { if (out.indexOf(v) < 0) out.push(v); });
    return out;
  }
  function orGroup(list) { return list.length === 1 ? list[0] : "(" + list.join(" OR ") + ")"; }

  // De zoekterm voor Shopify; null als er niets te zoeken valt.
  // Woorden moeten in de titel staan: "title:pikachu" is strikt (zonder dat geeft Shopify ook een Charjabug 025
  // of McDonald's 25/25 terug). title: kent geen prefix, dus het woord dat nog getypt wordt (opts.typing, laatste
  // woord zonder nummer erachter) gaat los mee; options[prefix]=last maakt daar een begin van.
  // opts.nameOnly: zonder nummer (voor de gelijkende kaarten). opts.loose: zoals Shopify zelf, alles los (vangnet).
  function buildServerQuery(p, opts) {
    opts = opts || {};
    var hasNum = hasNumberPart(p) && !opts.nameOnly;
    var parts = p.words.map(function (w, i) {
      if (opts.loose) return w;
      var typingLast = opts.typing && i === p.words.length - 1 && !hasNum;
      return typingLast ? w : "title:" + w;
    });
    if (hasNum) {
      if (p.num !== null) {
        parts.push(orGroup(numberVariants(p.numRaw)));
        if (p.total !== null) parts.push(String(p.total));
      } else {
        var pre = p.promo.prefix.toUpperCase();
        parts.push(orGroup(numberVariants(p.promo.raw).map(function (v) { return pre + v; })));
      }
    }
    if (!parts.length) return null;
    return parts.join(opts.loose ? " " : " AND ");
  }
  function hasNumberPart(p) { return p.num !== null || !!p.promo; }
  // Een "Nauwkeurigste resultaat" alleen bij minstens twee gegevens: twee woorden ("mega gengar"), woord + nummer
  // ("pikachu 25", "151 eevee") of een promocode ("svp 85" = prefix + nummer). Bij alleen "pikachu" is er geen
  // echte winnaar; dan een gewone rij (besluit Youri, 2026-10-19).
  function isSpecific(p) { return p.words.length + (p.num !== null ? 1 : 0) + (p.promo ? 2 : 0) >= 2; }

  // "Set - 025/165 - Naam - Variant", "SVP085 - Naam", of een productnaam zonder nummer
  function parseTitle(title) {
    var segs = String(title || "").split(" - ").map(function (s) { return s.trim(); });
    var info = { set: "", num: null, total: null, promo: null, name: String(title || ""), variant: "" };
    for (var i = 0; i < segs.length; i++) {
      var m;
      if ((m = segs[i].match(/^(\d{1,3})[a-z]?\/(\d{1,3})$/i))) {
        info.num = toInt(m[1]); info.total = toInt(m[2]);
      } else if ((m = segs[i].match(/^([a-z]{1,6})(\d{1,3})$/i)) && PROMO.indexOf(m[1].toLowerCase()) >= 0) {
        info.promo = { prefix: m[1].toLowerCase(), num: toInt(m[2]) };
      } else continue;
      info.set = segs.slice(0, i).join(" - ");
      info.name = segs[i + 1] || "";
      info.variant = segs.slice(i + 2).join(" - ");
      return info;
    }
    return info;
  }

  /* ---------- 4. score ---------- */
  function hasWord(hay, w, prefix) {
    // woordgrens aan het begin; het laatste woord mag een begin zijn (tijdens het typen)
    var i = -1, from = 0;
    while ((i = hay.indexOf(w, from)) >= 0) {
      var startOk = i === 0 || hay.charAt(i - 1) === " " || hay.charAt(i - 1) === "/";
      var after = hay.charAt(i + w.length);
      var endOk = prefix || after === "" || after === " " || after === "/";
      if (startOk && endOk) return true;
      from = i + 1;
    }
    return false;
  }

  // woord met meervoud-tolerantie: "bundels" telt als "bundel", "kaarten" als "kaart"
  function hasWordStem(hay, w, prefix) {
    if (hasWord(hay, w, prefix)) return true;
    if (w.length > 4 && /en$/.test(w) && hasWord(hay, w.slice(0, -2), false)) return true;
    return w.length > 3 && /s$/.test(w) && hasWord(hay, w.slice(0, -1), false);
  }

  function score(title, p, index) {
    var info = parseTitle(title);
    var T = norm(title), N = norm(info.name.replace(/\([^)]*\)/g, " ")), S = norm(info.set);
    var s = 0, inName = 0;
    p.words.forEach(function (w, i) {
      var prefix = i === p.words.length - 1 && !hasNumberPart(p);
      if (hasWordStem(N, w, prefix)) { s += 10; inName++; }
      else if (hasWordStem(S, w, prefix)) s += 4;
      else if (hasWordStem(T, w, prefix)) s += 2;
      else s -= 35; // de naam weegt zwaarder dan het nummer: andere Pikachu's vóór een Charjabug 025
    });
    if (p.words.length && inName === p.words.length) {
      s += 10;
      if (N === p.words.join(" ")) s += 8;
    }
    if (p.num !== null) {
      if (info.num === p.num) {
        s += 40;
        if (p.total !== null) s += info.total === p.total ? 10 : -5;
      } else if (hasWord(S, String(p.numRaw), false) || hasWord(S, String(p.num), false)) {
        s += 8; // "151 pikachu": het getal is de setnaam
      } else s -= info.num !== null || info.promo ? 10 : 15;
    } else if (p.promo) {
      if (info.promo && info.promo.num === p.promo.num) s += info.promo.prefix === p.promo.prefix ? 45 : 10;
      else s -= info.num !== null || info.promo ? 10 : 15;
    }
    if (info.variant) s -= 3;
    if (/\(/.test(info.name)) s -= 2;
    return s - (index || 0) * 0.001; // Shopify-volgorde als tie-break
  }

  // Harde regel: elk zoekwoord staat in de titel (woordgrens; het laatste woord mag een begin zijn, en een
  // meervoud op -s/-en telt ook: "bundels" vindt "Bundel"). Wie "pikachu" zoekt, ziet alleen Pikachu's.
  function wordsMatched(title, p) {
    var T = norm(title);
    return p.words.filter(function (w, i) {
      return hasWordStem(T, w, i === p.words.length - 1 && !hasNumberPart(p));
    }).length;
  }
  function matchesAll(title, p) { return wordsMatched(title, p) === p.words.length; }

  // items: [{t: titel, ...}] in Shopify-volgorde; geeft een nieuwe, gesorteerde lijst met .score, alleen met
  // titels waar alle zoekwoorden in staan. Heeft niemand alles (typfout: "pikachu xyz"), dan alleen de titels
  // met de meeste woorden (dus nog steeds alleen Pikachu's); heeft niemand één woord ("yugioh" tegen
  // "Yu-Gi-Oh!"), dan wat Shopify vond op score.
  function rank(items, p) {
    var best = 0;
    var scored = items.map(function (it, i) {
      var o = {}; for (var k in it) o[k] = it[k];
      // bij gelijke relevantie gaat op voorraad vóór uitverkocht (alleen tie-break: variant-verschil is al 2 of 3)
      o.score = score(it.t, p, i) + (it.a === false ? 0 : 0.5);
      o.hits = wordsMatched(it.t, p);
      if (o.hits > best) best = o.hits;
      return o;
    });
    return scored
      .filter(function (o) { return o.hits === best; })
      .sort(function (a, b) { return b.score - a.score; });
  }

  var api = { norm: norm, parseQuery: parseQuery, buildServerQuery: buildServerQuery, parseTitle: parseTitle, score: score, rank: rank, matchesAll: matchesAll, isSpecific: isSpecific };
  if (typeof module !== "undefined" && module.exports) module.exports = api;
  root.ccSearch = api;
  if (typeof document === "undefined") return;

  /* ---------- 3. ophalen ---------- */
  var routesRoot = (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || "/";
  var SEARCH_URL = (root.routes && root.routes.search_url) || routesRoot + "search";
  var SUGGEST_URL = (root.routes && root.routes.predictive_search_url) || routesRoot + "search/suggest";
  var cache = {};

  // stock: "show" (standaard, uitverkocht staat er gewoon tussen) of "hide" (schakelaar "Alleen op voorraad")
  function searchHref(serverQuery, stock) {
    return SEARCH_URL + "?q=" + encodeURIComponent(serverQuery) +
      "&type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=" + (stock === "hide" ? "hide" : "show");
  }
  // ontdubbelen: Shopify zet in zoekresultaten ?_pos=..&_sid=.. achter de productlink, en die verschilt per
  // zoekopdracht; dezelfde kaart uit de strikte en de naam-zoekopdracht zou anders twee keer in de rij staan
  function productKey(it) {
    if (it.id) return "id:" + it.id;
    try { return "p:" + new URL(it.u, window.location.href).pathname; } catch (e) { return "u:" + it.u; }
  }
  function fetchResults(serverQuery, signal) {
    var key = "r:" + serverQuery;
    if (cache[key]) return Promise.resolve(cache[key]);
    return fetch(searchHref(serverQuery) + "&section_id=cc-search-data", { signal: signal })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, "text/html");
        var el = doc.querySelector("script[data-cc-search-data]");
        var data = el ? JSON.parse(el.textContent) : { count: 0, items: [] };
        cache[key] = data;
        return data;
      });
  }
  function fetchCollections(q, signal) {
    var key = "c:" + q;
    if (cache[key]) return Promise.resolve(cache[key]);
    var url = SUGGEST_URL + ".json?q=" + encodeURIComponent(q) +
      "&resources%5Btype%5D=collection&resources%5Blimit%5D=4";
    return fetch(url, { signal: signal })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var list = (d && d.resources && d.resources.results && d.resources.results.collections) || [];
        cache[key] = list;
        return list;
      })
      .catch(function (e) { if (e && e.name === "AbortError") throw e; return []; });
  }

  /* ---------- weergave ---------- */
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; });
  }
  var ARROW = '<svg class="cc-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
  var MAX_TILES = 6; // beste match + 5, of 6 gewone tegels (vanaf 1280px); daaronder verbergt de CSS wat niet past

  function renderResults(box, q, p, data, collections, serverQuery) {
    var items = rank(data.items, p).slice(0, MAX_TILES);
    var html = "";
    if (!items.length) {
      html += '<div class="cc-search__empty">' +
        '<p class="cc-search__empty-title">Niets gevonden voor <strong>' + esc(q) + "</strong></p>" +
        '<p class="cc-search__empty-tip">Zoek op de naam van een kaart, of naam en nummer, zoals <em>pikachu 25</em> of <em>charizard 4/102</em>.</p>' +
        "</div>";
      var popular = document.querySelector("[data-cc-search-popular]");
      if (popular) html += popular.outerHTML;
      box.innerHTML = html;
      return;
    }
    var withBest = isSpecific(p);
    html += '<div class="cc-search__row' + (withBest ? "" : " cc-search__row--plain") + '" role="list">';
    items.forEach(function (it, i) {
      html += '<div class="cc-search__cell' + (i === 0 && withBest ? " cc-search__cell--best" : "") + '" role="listitem">' + it.h + "</div>";
    });
    html += "</div>";
    html += '<div class="cc-search__foot">';
    if (collections && collections.length) {
      html += '<div class="cc-search__sets"><span class="cc-search__label">Sets en categorieën</span>';
      collections.forEach(function (c) { html += '<a class="cc-pill-btn cc-pill-btn--sm" href="' + esc(c.url) + '">' + esc(c.title) + "</a>"; });
      html += "</div>";
    }
    var count = data.count || items.length;
    // de rij kan aangevuld zijn met andere kaarten van dezelfde naam; het aantal hoort bij de zoekterm zelf
    html += '<a class="cc-search__all cc-pill-ink" href="' + esc(searchHref(serverQuery)) + '">Bekijk ' +
      (count > 1 ? "alle " + count + " resultaten" : "het resultaat") + " voor “" + esc(q) + "”" + ARROW + "</a></div>";
    box.innerHTML = html;
    var best = box.querySelector(".cc-search__cell--best .cc-stile");
    if (best) best.classList.add("cc-stile--best");
  }

  /* ---------- zoekkaart in de header ---------- */
  function initPopup() {
    var rootEl = document.querySelector("[data-cc-search]");
    var form = document.getElementById("search_mini_form");
    var input = form && form.querySelector(".search__input");
    if (!rootEl || !input) return;
    var idle = rootEl.querySelector("[data-cc-search-idle]");
    var live = rootEl.querySelector("[data-cc-search-live]");
    var status = rootEl.querySelector("[data-cc-search-status]");
    var timer = null, controller = null, lastQ = "";

    // Aanbevolen producten staan in een <template> (SEO, zie snippets/search-popup.liquid): pas invullen bij de
    // eerste klik op de loep of focus in het veld. Bewust niet bij het laden, ook niet later: dan staan de foto's
    // weer in de pagina die Google rendert.
    var later = idle && idle.querySelector("template[data-cc-search-later]");
    function fillLater() {
      if (!later) return;
      later.parentNode.replaceChild(later.content.cloneNode(true), later);
      later = null;
    }
    if (later) {
      document.addEventListener("click", function (e) { if (e.target.closest(".top-search-toggle")) fillLater(); }, true);
      document.addEventListener("pointerover", function (e) { if (e.target.closest && e.target.closest(".top-search-toggle")) fillLater(); }, { passive: true });
      input.addEventListener("focus", fillLater);
    }

    function showIdle() {
      if (controller) controller.abort();
      lastQ = "";
      live.hidden = true; live.innerHTML = ""; idle.hidden = false;
      rootEl.classList.remove("is-loading");
    }
    function run(q) {
      var p = parseQuery(q);
      var strict = buildServerQuery(p);
      if (!strict) { showIdle(); return; }
      if (controller) controller.abort();
      controller = typeof AbortController !== "undefined" ? new AbortController() : null;
      var signal = controller ? controller.signal : undefined;
      lastQ = q;
      rootEl.classList.add("is-loading");
      // Volgorde: strikt (alle woorden in de titel); niets, dan het laatste woord als begin (nog aan het typen:
      // "pika"); niets, dan Shopify's eigen ruime zoekactie ("yugioh" tegen "Yu-Gi-Oh!"). De eerste met
      // resultaten wordt ook de link "Bekijk alle", zodat het aantal en de zoekpagina kloppen.
      var fallbacks = [buildServerQuery(p, { typing: true }), buildServerQuery(p, { loose: true })]
        .filter(function (x, i, a) { return x && x !== strict && a.indexOf(x) === i; });
      function firstWithResults(list) {
        return fetchResults(list[0], signal).then(function (d) {
          return d.count || list.length === 1 ? [d, list[0]] : firstWithResults(list.slice(1));
        });
      }
      // met een nummer ook de naam los: de rij vult zich dan met andere kaarten van dezelfde naam
      var nameOnly = hasNumberPart(p) && p.words.length ? buildServerQuery(p, { nameOnly: true }) : null;
      Promise.all([
        fetchResults(strict, signal),
        nameOnly ? fetchResults(nameOnly, signal) : Promise.resolve(null),
        p.words.length ? fetchCollections(p.words.join(" "), signal) : Promise.resolve([]),
      ]).then(function (res) {
        if (res[0].count) return [res[0], res[1], res[2], strict];
        if (res[1] && res[1].count) return [res[0], res[1], res[2], nameOnly]; // "pikachu 999": dan de Pikachu's
        if (!fallbacks.length) return [res[0], null, res[2], strict];
        return firstWithResults(fallbacks).then(function (r) { return [r[0], null, res[2], r[1]]; });
      }).then(function (res) {
        if (q !== lastQ) return;
        var data = res[0], extra = res[1];
        var seen = {}, items = [];
        data.items.concat(extra ? extra.items : []).forEach(function (it) {
          var key = productKey(it);
          if (!seen[key]) { seen[key] = 1; items.push(it); }
        });
        var count = data.count || (extra && extra.count) || 0;
        renderResults(live, q, p, { count: count, items: items }, res[2], res[3]);
        idle.hidden = true; live.hidden = false;
        rootEl.classList.remove("is-loading");
        if (status) status.textContent = items.length ? count + " resultaten" : "Geen resultaten";
      }).catch(function (e) {
        if (e && e.name === "AbortError") return;
        rootEl.classList.remove("is-loading");
      });
    }
    input.addEventListener("input", function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { showIdle(); return; }
      timer = setTimeout(function () { run(q); }, 220);
    });
    // populaire zoektermen: veld vullen en zoeken in plaats van naar de zoekpagina te gaan
    rootEl.addEventListener("click", function (e) {
      var a = e.target.closest && e.target.closest("[data-cc-q]");
      if (!a) return;
      e.preventDefault();
      input.value = a.getAttribute("data-cc-q");
      input.focus();
      run(input.value.trim());
    });
    // toetsenbord: pijl omlaag vanuit het veld naar de eerste tegel, pijlen tussen tegels en links, Esc sluit
    function focusables() {
      var scope = live.hidden ? idle : live;
      return Array.prototype.slice.call(scope.querySelectorAll("a[href]"));
    }
    form.addEventListener("keydown", function (e) {
      if (e.key === "ArrowDown" && e.target === input) {
        var f = focusables(); if (f.length) { e.preventDefault(); f[0].focus(); }
      }
    });
    rootEl.addEventListener("keydown", function (e) {
      var f = focusables(), i = f.indexOf(document.activeElement);
      if (i < 0) return;
      if (e.key === "ArrowRight" || e.key === "ArrowDown") { e.preventDefault(); (f[i + 1] || f[i]).focus(); }
      else if (e.key === "ArrowLeft" || e.key === "ArrowUp") { e.preventDefault(); (i === 0 ? input : f[i - 1]).focus(); }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      var sf = document.getElementById("search-form");
      if (!sf || !sf.classList.contains("bls__opend-popup-header")) return;
      sf.classList.remove("bls__opend-popup-header");
      document.documentElement.classList.remove("hside_opened", "open-search");
      var toggle = document.querySelector(".top-search-toggle");
      if (toggle) toggle.focus();
    });
  }

  /* ---------- formulieren naar /search: herschreven term meesturen ---------- */
  function initForms() {
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form || !form.getAttribute || !/\/search\/?$/.test(form.getAttribute("action") || "")) return;
      var field = form.querySelector('[name="q"]');
      if (!field) return;
      if (/title:|\sOR\s/.test(field.value)) return; // al een herschreven term
      var sq = buildServerQuery(parseQuery(field.value));
      if (!sq) return;
      e.preventDefault();
      var stockField = form.querySelector('[name="options[unavailable_products]"]');
      window.location.href = searchHref(sq, stockField && stockField.value);
    });
  }

  /* ---------- zoekpagina: vangnet bij 0 resultaten, beste match van pagina 1 in het slot ---------- */
  function initPage() {
    var page = document.querySelector("[data-cc-search-page]");
    if (!page) return;
    var p = parseQuery(page.getAttribute("data-cc-terms") || "");
    var stock = new URLSearchParams(window.location.search).get("options[unavailable_products]") === "hide" ? "hide" : "show";
    // strikt (title:) niets gevonden: één keer ruim zoeken zoals Shopify zelf (die term bevat geen title: meer).
    // Niet met "Alleen op voorraad" aan: dan betekent 0 meestal "alles uitverkocht", niet een andere schrijfwijze.
    if (stock === "show" && page.getAttribute("data-cc-count") === "0" && /title:/.test(page.getAttribute("data-cc-raw") || "")) {
      var loose = buildServerQuery(p, { loose: true });
      if (loose) { window.location.replace(searchHref(loose)); return; }
    }
    initStockToggle(page, stock);
    var slot = page.querySelector("[data-cc-search-best]");
    var tpls = Array.prototype.slice.call(page.querySelectorAll("template[data-cc-best-candidate]"));
    if (!slot || !tpls.length) return;
    if (!isSpecific(p)) return; // alleen "pikachu": geen beste match, gewoon het grid
    var ranked = rank(tpls.map(function (t) { return { t: t.getAttribute("data-title"), tpl: t }; }), p);
    var best = ranked[0];
    slot.appendChild(best.tpl.content.cloneNode(true));
    var tile = slot.querySelector(".cc-stile");
    if (!tile) return;
    tile.classList.add("cc-stile--best");
    slot.hidden = false;
    // dezelfde kaart staat ook in het grid: daar weghalen, anders staat hij twee keer in beeld
    var bestPath = new URL(tile.getAttribute("href"), window.location.href).pathname;
    Array.prototype.forEach.call(page.querySelectorAll(".bls__search-page-main > .bls__product-load:not([data-cc-search-best])"), function (cell) {
      var a = cell.querySelector('a[href*="/products/"]');
      if (a && new URL(a.getAttribute("href"), window.location.href).pathname === bestPath) cell.hidden = true;
    });
  }

  // schakelaar "Alleen op voorraad" naast het aantal: zet options[unavailable_products] op hide/show en laadt
  // de zoekpagina opnieuw (vanaf pagina 1); het zoekveld op de pagina neemt de stand mee
  function initStockToggle(page, stock) {
    var toggle = page.querySelector("[data-cc-stock-toggle]");
    if (!toggle) return;
    var input = toggle.querySelector("input");
    input.checked = stock === "hide";
    toggle.hidden = false;
    var field = page.querySelector('.cc-searchpage__form [name="options[unavailable_products]"]');
    if (field) field.value = stock;
    var emptyNote = page.querySelector("[data-cc-stock-empty]");
    if (emptyNote && stock === "hide") emptyNote.hidden = false;
    input.addEventListener("change", function () {
      var u = new URL(window.location.href);
      u.searchParams.set("options[unavailable_products]", input.checked ? "hide" : "show");
      u.searchParams.delete("page");
      toggle.classList.add("is-busy");
      window.location.href = u.toString();
    });
  }

  function init() { initPopup(); initForms(); initPage(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})(typeof window !== "undefined" ? window : globalThis);
